/**
 * This file is currently undergoing a deprecation process. We are gradually
 * pairing each of the query key computation functions below to their analog in
 * `@/lib/api-calls`. After that, Find All References is used to update each
 * usage to the wrapped query version. Finally, after Find All References is
 * used one more time to verify that nothing else in the codebase still uses the
 * old query key function. It is then safely deleted.
 *
 * In time, this entire file will be deleted. Refer to `@/lib/api-call` for
 * complementary information.
 */

export const QueryKeys = {
  getUser: (userId: string) => ['USER', userId],
  getOrg: (orgId: string) => ['ORG', orgId],
  getSchool: (schoolId: string) => ['SCHOOL', schoolId],
  getSchedule: (scheduleId: string) => ['SCHEDULE', scheduleId],
  getStudentLevel: (studentLevelId: string) => ['STUDENT_LEVEL', studentLevelId],
} as const;
